import { render, staticRenderFns } from "./background.vue?vue&type=template&id=ab03f336&scoped=true&lang=pug"
import script from "./background.vue?vue&type=script&lang=coffee"
export * from "./background.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab03f336",
  null
  
)

export default component.exports